import React from 'react';
import PropTypes from 'prop-types';
import {
  InformationPage, IntroIcon, CheckMarkIcon, Li,
} from '../css';
import basicInformationIcon from '../../../assets/auth/basicInformationIcon.svg';
import creditApplicationIcon from '../../../assets/auth/creditApplicationIcon.svg';
import accountActivationIcon from '../../../assets/auth/accountActivationIcon.svg';
import {
  H1, H2, H3, P, Span,
} from '../../../theme/typographySitecore';
import Button from './common';
import Column from '../../ReactComponent/Column';
import Row from '../../ReactComponent/Row';

const Step0 = ({ fields, onNext }) => {
  const {
    startSectionHeading,
    beginApplicationButton,
    welcomeText,
    doYouHaveAccountText,
    basicInformation,
    documentsYouNeed,
    contactInformationText,
    contactDocumentsList,
    creditApplication,
    creditApplicationText,
    creditDocumentsList,
    accountActivation,
    pendingAccountActivationText,
    emailAccountActivationText,
    startUsingAccountText,
  } = fields;

  return (
    <InformationPage>
      <Row>
        <Column>
          <H1 field={startSectionHeading} />
        </Column>
      </Row>
      <Button text={beginApplicationButton} onClick={onNext} />
      <P center field={welcomeText} />
      <P center field={doYouHaveAccountText} />
      <IntroIcon src={basicInformationIcon} />
      <H2 field={basicInformation} />
      <P center field={contactInformationText} />
      <H3 field={documentsYouNeed} />
      <List data={contactDocumentsList} />
      <IntroIcon src={creditApplicationIcon} />
      <H2 field={creditApplication} />
      <P center field={creditApplicationText} />
      <H3 field={documentsYouNeed} />
      <List data={creditDocumentsList} />
      <IntroIcon src={accountActivationIcon} />
      <H2 field={accountActivation} />
      <P center field={pendingAccountActivationText} />
      <P center field={emailAccountActivationText} />
      <P center field={startUsingAccountText} />
      <Button text={beginApplicationButton} onClick={onNext} />
    </InformationPage>
  );
};

const List = ({ data }) => (
  <ul>
    {data.map(({ fields: { documentName } }, id) => (
      <Li key={documentName + id}>
        <CheckMarkIcon />
        <Span field={documentName} />
      </Li>
    ))}
  </ul>
);

Step0.propTypes = {
  fields: PropTypes.shape({
    startSectionHeading: PropTypes.object,
    beginApplicationButton: PropTypes.object,
    welcomeText: PropTypes.object,
    doYouHaveAccountText: PropTypes.object,
    basicInformation: PropTypes.object,
    documentsYouNeed: PropTypes.object,
    contactInformationText: PropTypes.object,
    contactDocumentsList: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          documentName: PropTypes.object,
        }),
      }),
    ),
    creditApplication: PropTypes.object,
    creditApplicationText: PropTypes.object,
    creditDocumentsList: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({
          documentName: PropTypes.object,
        }),
      }),
    ),
    accountActivation: PropTypes.object,
    pendingAccountActivationText: PropTypes.object,
    emailAccountActivationText: PropTypes.object,
    startUsingAccountText: PropTypes.object,
  }),
  onNext: PropTypes.func,
};

List.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      fields: PropTypes.shape({
        documentName: PropTypes.object,
      }),
    }),
  ),
};

export default Step0;
